import { FacetDrilldown } from '@mp/shared/facets/domain';

import { ArticleFacetSearchRequestBase } from './article-facet-search-request';

/**
 * Beschreibt die Abfrage für den Drilldown einer Facette (Nachladen).
 */
export interface ArticleFacetDrilldownSearchRequest extends ArticleFacetSearchRequestBase {
  /**
   * Gibt den Typ der Facette an, für die der Drilldown ausgeführt wird.
   */
  facetType: DrilldownFacetType;
  /**
   * Gibt das Merkmal an, das aufgeklappt wird.
   */
  drilldown: FacetDrilldown;
}

/**
 * Attribut-Facetten-Typen für den Drilldown-Request.
 */
export enum DrilldownFacetType {
  ArticleFeature = 'ArticleFeature',
  EClassFeature = 'EClassFeature',
  PharmaceuticalFeature = 'PharmaceuticalFeature',
}
